var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 4.00004V5.61337C14.666 6.66671 13.9993 7.33337 12.946 7.33337H10.666V2.67337C10.666 1.93337 11.2727 1.33337 12.0127 1.33337C12.7394 1.34004 13.406 1.63337 13.886 2.11337C14.366 2.60004 14.666 3.26671 14.666 4.00004Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 4.66671V14C1.33398 14.5534 1.96066 14.8667 2.40066 14.5334L3.54065 13.68C3.80732 13.48 4.18065 13.5067 4.42065 13.7467L5.52731 14.86C5.78731 15.12 6.21399 15.12 6.47399 14.86L7.59398 13.74C7.82732 13.5067 8.20065 13.48 8.46065 13.68L9.60065 14.5334C10.0406 14.86 10.6673 14.5467 10.6673 14V2.66671C10.6673 1.93337 11.2673 1.33337 12.0007 1.33337H4.66732H4.00065C2.00065 1.33337 1.33398 2.52671 1.33398 4.00004V4.66671Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5H4C3.72667 6.5 3.5 6.27333 3.5 6C3.5 5.72667 3.72667 5.5 4 5.5H8C8.27333 5.5 8.5 5.72667 8.5 6C8.5 6.27333 8.27333 6.5 8 6.5Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16663H4.5C4.22667 9.16663 4 8.93996 4 8.66663C4 8.39329 4.22667 8.16663 4.5 8.16663H7.5C7.77333 8.16663 8 8.39329 8 8.66663C8 8.93996 7.77333 9.16663 7.5 9.16663Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.d6bf9ff558434a4ae9b1a69e21e317eb.svg";
export { ForwardRef as ReactComponent };